@import (reference) '../../../../constants/spacing.module.less';

.default-icon {
  height: 16px;
  color: var(--default--icon--fill-color--10);
}

.shipped-icon {
  height: 16px;
  color: var(--default--icon--fill-color--11);
}

.button-content {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: @space-8;
}

.delete-button {
  height: 24px;
  width: 24px;
  padding: @space-4;
  display: flex;
  align-items: center;
  justify-content: center;
}

.delete-button-icon {
  height: 16px;
  width: 16px;
  color: var(--primary--icon--fill-color--2);
}
